import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { LoginRecoveryFacade } from '@pages/login-recovery-options/facades/login-recovery.facade';
import { ForgotUsernameCredentials } from '@pages/login-recovery-options/models/forgot-username-credentials.interface';
import { TableTooltipComponent } from '@design/table/components/table-tooltip/table-tooltip.component';

@Component({
  selector: 'itc-recover-username-email-sent',
  templateUrl: 'recover-username-email-sent.component.html',
  styleUrl: 'recover-username-email-sent.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslatePipe, TableTooltipComponent],
})
export class RecoverUsernameEmailSentComponent {
  private readonly loginRecoveryFacade = inject(LoginRecoveryFacade);

  readonly usernameRecoveryCredentials = computed(() => this.loginRecoveryFacade.recoveryCredentials() as ForgotUsernameCredentials);
}
